export default {
	type: 'object',
	properties: {
		projectUrl: { type: 'string' },
		description: { type: 'string' },
		title: { type: 'string' },
	},
	required: ['projectUrl', 'title', 'description'],
	additionalProperties: false,
}
